// extracted by mini-css-extract-plugin
export var image = "_j8-0";